module.exports = __webpack_public_path__ + "static/flags/PA-e7a7491deb04ef23e7f159290a818378.gif";